import viewTransitionNavUtility from "@Utils/viewTransitionNavUtility";

export const webAppBackHandler = (history: any) => {
  viewTransitionNavUtility(() => {
    history.goBack();
  }, "left-to-right");
};
export default webAppBackHandler;
